<template>
  <v-bottom-sheet v-model="show" persistent>
    <v-sheet class="text-center">
      <v-card class="d-flex justify-end" elevation="0">
        <v-btn class="mt-2 mr-2" color="error" @click="handleClose">
          close
        </v-btn>
      </v-card>

      <div class="ma-1"></div>

      <v-row class="d-flex justify-center">
        <v-col cols=3 class="ma-1">
          <TitleContainerComponent 
            title="Infos"
            :value="selectedFilters"
            @filterJobs="handleFilterJobs"
            @input="onSelectedFiltersChanged">
            <h4 v-if="selectedKiosks.length == 0">No kiosk selected</h4>
            <h4 v-else-if="selectedKiosks.length > 1">
              More than one kiosk selected
            </h4>

            <v-card v-else class="mt-4 text-left" elevation="0">
              <v-row>
                <v-col cols="5">
                  <strong>nuage api id</strong>
                </v-col>
                <v-col cols="7">
                  <p>{{ selectedKiosks[0].id }}</p>
                </v-col>
              </v-row>
              <v-row class="pt-1">
                <v-col cols="5">
                  <strong>extranet id</strong>
                </v-col>
                <v-col cols="7">
                  <p>{{ selectedKiosks[0].idExtranet }}</p>
                </v-col>
              </v-row>
              <v-row class="pt-1">
                <v-col cols="5">
                  <strong>name</strong>
                </v-col>
                <v-col cols="7">
                  <p>{{ selectedKiosks[0].name }}</p>
                </v-col>
              </v-row>

              <v-row class="pt-1">
                <v-col cols="5">
                  <strong
                    >mac
                    <address></address
                  ></strong>
                </v-col>
                <v-col cols="7">
                  <p>{{ selectedKiosks[0].macAddr }}</p>
                </v-col>
              </v-row>

              <v-row class="pt-1">
                <v-col cols="5">
                  <strong>tags</strong>
                </v-col>
                <v-col cols="7">
                  <p>
                    {{
                      selectedKiosks[0].tags !== null
                        ? selectedKiosks[0].tags.map((o) => o.name)
                        : "[ ]"
                    }}
                  </p>
                </v-col>
              </v-row>
              <v-row class="pt-1">
                <v-col cols="5">
                  <strong>vpn
                    <address></address>
                  </strong>
                </v-col>
                <v-col cols="7">
                  <p>{{ selectedKiosks[0].vpnAddress }}</p>
                </v-col>
              </v-row>
              <v-row class="pt-1">
                <v-col cols="5">
                  <strong>wedeal-custom
                    <address></address>
                  </strong>
                </v-col>
                <v-col cols="7">
                  <p>{{ selectedKiosks[0].versionWeCommon != null ? selectedKiosks[0].versionWeCommon : "No data" }}</p>
                </v-col>
              </v-row>
            </v-card>
          </TitleContainerComponent>
        </v-col>

        <v-col cols=3 class="ma-1">
          <TitleContainerComponent title="Ping History">
            <h4 v-if="selectedKiosks.length == 0">No kiosk selected</h4>
            <h4 v-else-if="selectedKiosks.length > 1">
              More than one kiosk selected
            </h4>
            <v-virtual-scroll
              v-else
              :items="lastCheckHistory"
              :item-height="100"
              height="300"
            >
              <template v-slot="{ item }">
                <PingHistoryList :item="item"></PingHistoryList>
              </template>
            </v-virtual-scroll>
          </TitleContainerComponent>
        </v-col>

        <v-col cols=5 class="ma-1">
          <TitleContainerComponent 
            title="Activity" 
            :value="selectedFilters"
            @input="onSelectedFiltersChanged"
            @filterJobs="handleFilterJobs">
            <h4 v-if="selectedKiosks.length == 0">No kiosk selected</h4>
            <h4 v-else-if="selectedKiosks.length > 1">
              More than one kiosk selected
            </h4>

            <template v-else>
        <v-virtual-scroll
            :items="jobs"
            :key="(selectedKiosks[0] && selectedKiosks[0].name) + '|' + selectedFilters.join(',')"
            :item-height="100"
            height="300"
            @scroll.native="onJobsScrollThrottled"
        >
            <template v-slot="{ item }">
                <JobActivityTimeline :item="item" @deleteJob="deleteJob"></JobActivityTimeline>
            </template>
        </v-virtual-scroll>

        <!-- Indicateur de chargement de page suivante -->
        <div v-if="jobsLoading" class="text-center pa-2">
            <v-progress-circular indeterminate color="primary" size="20" />
        </div>

        <!-- Marqueur de fin -->
        <div v-else-if="!jobsHasMore && jobsHasLoadedMore" class="text-center pa-2 caption grey--text">
            Fin de l'historique
        </div>
    </template>
          </TitleContainerComponent>
        </v-col>
</v-row>
<v-row  class="d-flex justify-center">
        <v-col cols=11 class="ma-1">
          <job-buttons-container
            :selectedKiosks="selectedKiosks.map((o) => o.name)"
          ></job-buttons-container>
        </v-col>
      </v-row>
    
    </v-sheet>

  </v-bottom-sheet>
</template>


<script>
import TitleContainerComponent from "@/components/genericComponents/TitleContainerComponent";
import JobButtonsContainer from "./customComponents/JobButtonsContainer.vue";
import JobActivityTimeline from "./customComponents/JobActivityTimeline.vue";
import PingHistoryList from "./customComponents/PingHistoryList.vue";
import { store } from "@/models/Store.js";
export default {
  props: {
    show: Boolean,
    jobsLoading: { type: Boolean, default: false },
    jobsHasMore: { type: Boolean, default: true },
    jobsHasLoadedMore: { type: Boolean, default: false },
    selectedFilters: { type: Array, default: () => [] }
  },
  components: {
    TitleContainerComponent,
    JobButtonsContainer,
    JobActivityTimeline,
    PingHistoryList,
  },
 
  data: () => ({
    iterator: null,
    store:store,
  }),
  created() {
    // Throttle : limite l'exécution à une fois toutes les 200ms
    let lastCall = 0;
    this.onJobsScrollThrottled = (event) => {
        const now = Date.now();
        if (now - lastCall < 200) return;
        lastCall = now;
        this.onJobsScroll(event);
    };
  },
  methods: {
    deleteJob(item) {
      this.$emit("deleteJob", item)
    },
    handleClose: function () {
      this.$emit("closeButtonPressed");
    },
    handleFilterJobs(removedTypes) {
      this.$emit("filterToMainBoard", removedTypes)
    },
    onJobsScroll(event) {
      if (this.jobsLoading || !this.jobsHasMore) return;

      const el = event.target;
      const distanceFromBottom = el.scrollHeight - el.scrollTop - el.clientHeight;

      if (distanceFromBottom < 200) {
        this.$emit("loadMoreJobs")
      }
    },
    onSelectedFiltersChanged(newFilters) {
        this.$emit('update:selectedFilters', newFilters);
    }
  },
  computed: {
    selectedKiosks() {
      return store.state.selectedKiosks;
    },
    /**
     * Give the lastCheck array
     */
    lastCheckHistory() {
      if(store.checkHistoryList != undefined && store.checkHistoryList[0] != undefined)
        return store.checkHistoryList[0].lastCheck.reverse();
      return [];
    },
     jobs() {
              return store.state.selectedKiosks[0]?.jobsFlag?.jobs;
     }
  },
};
</script>